import { mensagemCampoObrigatorio, mensagemMinimo3Caracteres } from '@core/util/mensagemUtil';
import { validateCnpj, validateCpf } from 'app/utils/validation';
import * as Yup from 'yup';

export const useOnboardingSchemaDadosCadastrais = () =>
  Yup.object().shape({
    comercializacao: Yup.string()
      .nullable()
      .required(mensagemCampoObrigatorio('a comercialização')),
    pessoa: Yup.object().shape({
      nome: Yup.string()
        .min(3, mensagemMinimo3Caracteres)
        .required('Informe o nome'),
      tipoPessoa: Yup.string().nullable(),
      inscricaoMunicipal: Yup.string()
        .min(3, mensagemMinimo3Caracteres)
        .nullable(),
      pessoaJuridica: Yup.object().shape({
        cnpj: Yup.string()
          .test('test cnpj', 'CNPJ inválido', (value) => {
            return value ? validateCnpj(value) : true;
          })
          .nullable(),
        razaoSocial: Yup.string()
          .min(3, mensagemMinimo3Caracteres)
          .nullable(),
        inscricaoEstadual: Yup.string()
          .min(3, mensagemMinimo3Caracteres)
          .nullable(),
      }),
      pessoaFisica: Yup.object().shape({
        cpf: Yup.string().test('test cpf', 'CPF inválido', (value) => {
          if (value) {
            const validate = validateCpf(value);
            return validate;
          }
          return true;
        }),
        identidade: Yup.string().min(3, mensagemMinimo3Caracteres),
        dataNascimento: Yup.object().nullable(),
        identificadorEstrangeiro: Yup.string().min(3, mensagemMinimo3Caracteres),
      }),
    }),
  });

export const useOnboardingSchemaInformacoesFiscais = () =>
  Yup.object().shape({
    produtorRural: Yup.string()
      .nullable()
      .required('Informe a opção produtor rural'),
    optanteSimples: Yup.string()
      .nullable()
      .required('Informe a opção simples nacional'),
    regimeTributario: Yup.string()
      .nullable()
      .required('Informe o regime tributário'),
    regimeTributarioEspecial: Yup.string()
      .nullable()
      .required('Informe o regime tributário especial'),
    situacaoTributariaPis: Yup.string().nullable(),
    situacaoTributariaCofins: Yup.string().nullable(),
    aliquotaPis: Yup.string().test('aliquotaPis', 'Informe o valor da Aliquota PIS.', function(aliquotaPis) {
      return validarRequired(this.parent.situacaoTributariaPis, aliquotaPis);
    }),
    aliquotaCofins: Yup.string().test('aliquotaCofins', 'Informe o valor da Aliquota COFINS.', function(
      aliquotaCofins
    ) {
      return validarRequired(this.parent.situacaoTributariaCofins, aliquotaCofins);
    }),
    cstSituacaoTributaria: Yup.string()
      .nullable()
      .when('ibsCbs', {
        is: true,
        then: Yup.string()
          .nullable()
          .required('Informe o código de situação tributária'),
      }),
    cstClassificacaoTributaria: Yup.string()
      .nullable()
      .when(['ibsCbs', 'cstSituacaoTributaria'], {
        is: (ibsCbs, cstSituacaoTributaria) => ibsCbs === true && cstSituacaoTributaria,
        then: (schema) => schema.required('Informe o código de classificação tributária'),
        otherwise: (schema) => schema.notRequired(),
      }),
    contribuinteIbs: Yup.string()
      .nullable()
      .when('ibsCbs', {
        is: true,
        then: Yup.string()
          .nullable()
          .required('Informe se é contribuinte IBS'),
      }),
    contribuinteCbs: Yup.string()
      .nullable()
      .when('ibsCbs', {
        is: true,
        then: Yup.string()
          .nullable()
          .required('Informe se é contribuinte CBS'),
      }),
    contribuinteIs: Yup.string()
      .nullable()
      .when('ibsCbs', {
        is: true,
        then: Yup.string()
          .nullable()
          .required('Informe se é contribuinte IS'),
      }),
  });

export const validarRequired = (situacaoTributaria, aliquota) => {
  if (situacaoTributaria) {
    const requiredValues = [
      'OPERACAO_TRIBUTAVEL_01',
      'OPERACAO_TRIBUTAVEL_02',
      'OPERACAO_TRIBUTAVEL_03',
      'OPERACAO_TRIBUTAVEL_05',
      'OPERACAO_TRIBUTAVEL_49',
    ];
    if (requiredValues.includes(situacaoTributaria)) {
      if (aliquota && aliquota === 0) {
        return false;
      }

      return !!aliquota;
    }
  }
  return true;
};

export const useOnboardingSchemaContaBancaria = () =>
  Yup.object().shape({
    pessoa: Yup.object().shape({
      conta: Yup.object().shape({
        descricao: Yup.string()
          .min(3, mensagemMinimo3Caracteres)
          .required('Informe a descrição'),
        contaBancaria: Yup.object().shape({
          tipoConta: Yup.string()
            .nullable()
            .required('Informe o tipo da conta'),
          banco: Yup.object()
            .nullable()
            .required('Informe o banco'),
          agencia: Yup.string().required('Informe a agência'),
          numeroConta: Yup.string().required('Informe o número da conta'),
          contaDigito: Yup.string().required('Informe o dígito da conta'),
          saldoInicial: Yup.string().required('Informe o saldo inicial'),
          dataSaldo: Yup.string()
            .required('Informe a data do saldo')
            .nullable(),
        }),
      }),
    }),
  });
